/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSignal: {
  name: 'signal';
  data: string;
} = {
  name: 'signal',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M21 4a1 1 0 1 0-2 0v16a1 1 0 1 0 2 0V4Zm-6 2a1 1 0 0 1 1 1v13a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1Zm-4 4a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0V10Zm-5 3a1 1 0 1 0-2 0v7a1 1 0 1 0 2 0v-7Z" fill="currentColor"/></svg>`,
};
